import { render, staticRenderFns } from "./WavePlayer.vue?vue&type=template&id=36c68ddd&scoped=true"
import script from "./WavePlayer.vue?vue&type=script&lang=js"
export * from "./WavePlayer.vue?vue&type=script&lang=js"
import style0 from "./WavePlayer.vue?vue&type=style&index=0&id=36c68ddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c68ddd",
  null
  
)

export default component.exports